import { createStyles } from '@material-ui/core/styles';

export default createStyles({
    formContainer: {
        display: 'flex',
        backgroundColor: '#dddddd',
        padding: '10px 20px 30px 20px'
    },
    leftContainer: {
        'width': '60%',
        'height': '100%',
        'background': 'white',
        'borderRadius': '4px',
        '& > div:first-child': {
            paddingBottom: '100px'
        },
        '& .MuiGrid-item': {
            maxWidth: '100%',
            flexBasis: '100%',
        },
        '& .MuiPaper-root': {
            boxShadow: 'none'
        }
    },
    leftContainerWOSummary: {
        'width': '100%',
        'height': '100%',
        'background': 'white',
        'borderRadius': '4px',
        '& > div:first-child': {
            paddingBottom: '100px'
        },
        '& .MuiGrid-item': {
            maxWidth: '100%',
            flexBasis: '100%',
        },
        '& .MuiPaper-root': {
            boxShadow: 'none'
        }
    },
    rightContainer: {
        'width': '40%',
        'height': '100%',
        'display': 'flex',
        '& .MuiGrid-item': {
            maxWidth: '100%',
            flexBasis: '100%',
            minWidth: '100% !important',
            width: '100% !important',
        },
        '& .MuiPaper-root': {
            boxShadow: 'none',
            margin: '0px 0px 20px 20px'
        },
        '& .formViewContainer': {
            flexWrap: 'nowrap',
            flexDirection: 'column-reverse',
            justifyContent: 'flex-end'
        },
        '& div > div > div > .MuiGrid-container .MuiGrid-item:nth-child(2) .MuiPaper-root': {
            boxShadow: '0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12)'
        },
    },
    toggleContainer: {
        'display': 'flex',
        'flexDirection': 'column',
        'backgroundColor': '#dddddd',
        'bottom': 0,
        'position': 'sticky',
        'zIndex': 2,
        'width': '100%',
        'height': '38px',
        '& label': {
            paddingLeft: '16px',
            background: '#dddddd'
        }
    },
    calculatorFooter: {
        height: '60px',
        display: 'flex',
        flexWrap: 'nowrap',
        flexDirection: 'row-reverse',
        width: '100%',
        backgroundColor: '#E5E5E5',
        borderRadius: '0px 0px 4px 4px',
    },
    calculateButton: {
        'boxShadow': 'none',
        'height': '100%',
        'backgroundColor': '#E5E5E5',
        '&.MuiButton-disabled': {
            backgroundColor: 'unset'
        }
    },
    focusOuter: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        overflow: 'auto'
    },
    focusInner: {
        flex: 1,
        overflowY: 'auto',
        overflowX: 'hidden',
        scrollbarWidth: 'thin'
    },
});
